import { IProductPageResponse } from "@faire/web-api/indigofair/data/IProductPageResponse";
import { Row } from "@faire/web/slate/Layout";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React, { lazy } from "react";
import styled from "styled-components";



import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export interface IPDPBrandInfoProps {
  className?: string;
  productToken: string;
  brandToken: string;
  brand?: IProductPageResponse.IPdpBrand;
  shouldHideTopButtons?: boolean;
}

export const LazyBrandInfoRow = lazy(() =>
  import(/* webpackChunkName: "retailer-PDP-brand-info-row" */ "./BrandInfoRow")
    .then((m) => ({ default: m.BrandInfoRow }))
    .catch(handleComponentLoadError)
);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
LazyBrandInfoRow.displayName = "LazyBrandInfoRow";

export const BrandInfoRowFallback: React.FC = () => (
  <Wrapper>
    <LoadingSpinner />
  </Wrapper>
);

const Wrapper = styled(Row).attrs({
  align: "center",
  justify: "center",
})`
  height: 300px;
  ${responsiveMediaQueries.tabletAndAbove} {
    height: 690px;
  }
`;